export default __webpack_public_path__ + "locales/lo-LA/DeleteDialog.json?hash=43339de91a7d6d8cc81e3c562fd9afab";